<template>
  <div class="cart-checkout">
    <p class="cart-title">{{ Translator('front.cart.payment.title_payment') }}</p>
    <div class="form-display form-display--placeholder">
      <div class="cart-loader" v-if="!isInit"></div>
      <p class="cart-error" v-if="errorPaiement">{{ errorPaiement }}</p>
      <form class="std-form std-form--card" @submit="onSubmitPayment" ref="formPayment" v-if="isInit && order.totalTtc > 0">
        <div v-if="order.cartPayment.method.code === 'cb-stripe'">
          <div class="cart-loader" v-if="loadMethod === true"></div>
          <div class="cart-form-wrapper" v-else>
            <div class="form-group form-group-number form-group--is-placeholder">
              <div class="form-label-container">
                <label for="payment-number" class="control-label required">{{ Translator('front.cart.payment.card_number')}}</label>
              </div>
              <div class="card-input" ref="cardNumber"></div>
              <p class="form-error" v-if="errorcardNumber">{{ errorcardNumber }}</p>
            </div>
            <div class="form-row">
              <div class="form-group form-group-expiry form-group--is-placeholder">
                <div class="form-label-container">
                  <label for="payment-expiration" class="control-label required">{{ Translator('front.cart.payment.card_expiration')}}</label>
                </div>
                <div class="card-input" ref="cardExpiry"></div>
                <p class="form-error" v-if="errorcardExpiry">{{ errorcardExpiry }}</p>
              </div>
              <div class="form-group form-group-cvc form-group--is-placeholder">
                <div class="form-label-container">
                  <label for="payment-code" class="control-label required">{{ Translator('front.cart.payment.card_code')}}</label>
                </div>
                <div class="card-input" ref="cardCvc"></div>
                <p class="form-error" v-if="errorcardCvc">{{ errorcardCvc }}</p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="order.cartPayment.method.code === 'cb-paypal'">
          <div class="cart-loader" v-if="loadMethod === true"></div>
          <div class="cart-form-wrapper" v-else>
            <div class="form-group form-group-number form-group--is-placeholder">
              <div class="form-label-container">
                <label for="payment-number" class="control-label required">{{ Translator('front.cart.payment.card_number')}}</label>
              </div>
              <div class="card-area" ref="cardNumber" id="paypal-cardNumber"></div>
              <p class="form-error" v-if="errorcardNumber">{{ errorcardNumber }}</p>
            </div>
            <div class="form-row">
              <div class="form-group form-group-expiry form-group--is-placeholder">
                <div class="form-label-container">
                  <label for="payment-expiration" class="control-label required">{{ Translator('front.cart.payment.card_expiration')}}</label>
                </div>
                <div class="card-area" ref="cardExpiry" id="paypal-expirationDate"></div>
                <p class="form-error" v-if="errorcardExpiry">{{ errorcardExpiry }}</p>
              </div>
              <div class="form-group form-group-cvc form-group--is-placeholder">
                <div class="form-label-container">
                  <label for="payment-code" class="control-label required">{{ Translator('front.cart.payment.card_code')}}</label>
                </div>
                <div class="card-area" ref="cardCvc" id="paypal-cvc"></div>
                <p class="form-error" v-if="errorcardCvc">{{ errorcardCvc }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group checkbox" :class="{'is-error': errorCheckConditions && !terms}" v-if="isInit && !loadMethod">
          <label>
            <input type="checkbox" v-model="terms">
            <span v-html="Translator('front.cart.payment.disclamer', {'conditions_link': linkCGV})"></span>
          </label>
        </div>
        <p class="form-error" v-if="errorCheckConditions && !terms">{{ Translator('front.cart.payment.disclamer_error') }}</p>
      </form>
      <div id="button-paypal" v-if="order && order.totalTtc > 0 && order.cartPayment.method.code === 'paypal'">
        <div class="cart-loader" v-if="loadMethod"></div>
      </div>
      <button type="button" @click="onSubmit" v-if="isInit && !loadMethod && order.cartPayment.method.code !== 'paypal' && terms" class="cart-button" :class="{'is-loading': isLoadingPayment}">
        <span>{{ Translator('front.cart.checkout.button') }}</span>
      </button>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import AppControlService from '@/services/AppControl';
import OrdersService from '@/services/Orders';
import CardService from '@/services/Card';

export default {
  name: 'cart-payment',
  components: {
  },
  data () {
    return {
      order: null,
      terms: false,
      isLoadingPayment: false,
      loadMethod: true,
      linkCGV: null,
      errorCheckConditions: false,
      formPayment: {
        method: null,
        number: null,
        expiration: null,
        code: null
      },
      errorPaiement: null,
      errorcardNumber: null,
      errorcardExpiry: null,
      errorcardCvc: null,
      isInit: false,
    }
  },
  created() {
    this._onUpdateCart = this._onUpdateCart.bind(this);
    OrdersService.on('updated', this._onUpdateCart);
  },

  mounted() {
    this._onUpdateCart();
  },

  beforeDestroy() {
    OrdersService.off('updated', this._onUpdateCart);
    if(this._card) {
      if (this._card.cardNumber) {
        this._card.cardNumber.destroy();
        this._card.cardNumber.off('change', this._onCheckError);
      }
      if (this._card.cardExpiry) {
        this._card.cardExpiry.destroy();
        this._card.cardExpiry.off('change', this._onCheckError);
      }
      if (this._card.cardCvc) {
        this._card.cardCvc.destroy();
        this._card.cardCvc.off('change', this._onCheckError);
      }
    }
  },
  methods: {
    onSubmit() {
      this._onSubmit();
    },

    onSubmitPayment(pEvt) {
      pEvt.preventDefault();
    },

    _onUpdateCart() {
      if (OrdersService.cart && !this.isInit) {
        this.order = OrdersService.cart;
        this._checkPaymentMethod();
        this.isInit = true;
      }
    },

    _checkPaymentMethod() {
      CardService.initPayment().then( res => {
        if(this.order.cartPayment.method && this.order.cartPayment.method.code === 'cb-stripe') {
          this._card = res;
          this.loadMethod = false;
          setTimeout(() => {
            if(this._card.cardNumber && this.$refs.cardNumber[0]) {
              this._card.cardNumber.mount(this.$refs.cardNumber[0]);
              this._card.cardNumber.on('change', this._onCheckError);
            }
            if(this._card.cardExpiry && this.$refs.cardExpiry[0]) {
              this._card.cardExpiry.mount(this.$refs.cardExpiry[0]);
              this._card.cardExpiry.on('change', this._onCheckError);
            }
            if(this._card.cardCvc && this.$refs.cardCvc[0]) {
              this._card.cardCvc.mount(this.$refs.cardCvc[0]);
              this._card.cardCvc.on('change', this._onCheckError);
            }
          });
        } else if(this.order.cartPayment.method && this.order.cartPayment.method.code === 'cb-paypal') {
          const paypal = window.paypal;
          if(paypal.HostedFields.isEligible()) {
            this.loadMethod = false;
            this._hostFields = paypal.HostedFields.render({
              createOrder: () => {
                return CardService.createPaypalCB().then( res => {
                  return res.data.order_id;
                });
              },
              styles: {
                '.valid': {
                  color: '#1da763',
                },
                '.invalid': {
                  color: '#c82a28',
                },
              },
              fields: {
                number: {
                  selector: '#paypal-cardNumber',
                  placeholder: '4111 1111 1111 1111',
                },
                cvv: {
                  selector: '#paypal-cvc',
                  placeholder: '123',
                },
                expirationDate: {
                  selector: '#paypal-expirationDate',
                  placeholder: 'MM/YY',
                },
              },
            }).then( (cardFields) => {
              this._cardFields = cardFields;
            }).catch( err => {
              console.error(err);
            });
          }

        } else if(this.order.cartPayment.method && this.order.cartPayment.method.code === 'paypal') {
          res.Buttons({
            locale: '{{ locale }}',
            style: {
              label: 'paypal'
            },
            onInit: () => {
              this.loadMethod = false;
            },
            createOrder: () => {
              if(!this.isInit) return;
              if(this.isLoadingPayment) return;
              this.errorCheckConditions = !this.terms;
              if(!this.terms) {
                AppControlService.abortStep();
                return;
              }
              this.isLoadingPayment = true;
              AppControlService.validStep();

              return OrdersService.confirm().then( () => {
                return fetch(CardService.paypalConfig.create_paypal_order_url, {
                    method: 'post'
                }).then((res) => {
                  if(res.status === 400) {
                    console.error(res);
                    AppControlService.abortStep();
                    this.isLoadingPayment = false;
                  } else return res.json();
                }).then(data => data.order_id);
              }).catch((err) => {
                let error = err.error?.message ? err.error.message : err.response?.message;
                if(err.response?.data) error = err.response.data['hydra:description'];
                this.errorPaiement = error;
                AppControlService.abortStep();
                this.isLoadingPayment = false;
              });
            },
            onApprove: () => {
              axios.post(CardService.paypalConfig.complete_paypal_order_url).then(() => {
                this._paymentSuccess();
              }).catch( err => {
                let error = err.error?.message ? err.error.message : err.response?.message;
                if(err.response?.data) error = err.response.data['hydra:description'];
                this.errorPaiement = error;
                AppControlService.abortStep();
              }).then( () => {
                this.isLoadingPayment = false;
              });
            },
            onCancel: (data) => {
              AppControlService.abortStep();
              axios.post(CardService.paypalConfig.cancel_paypal_payment_url, {
                paypalOrderId: data.orderID
              }).then().then( () => {
                this.isLoadingPayment = false;
              });
            },
            onError: () => {
              AppControlService.abortStep();
              axios.post(CardService.paypalConfig.paypal_payment_on_error_url).then().then( () => {
                this.isLoadingPayment = false;
              });
            }
          }).render('#button-paypal')
        }
      })
    },

    _paymentSuccess() {
      AppControlService.goToNextStep();
      // Send analytics purchase
      const cart = OrdersService.cart;
      const datas = {
        transaction_id: `${cart.cartPayment.method.code}_${cart.cartPayment.id}`,
        value: cart.totalItemsPriceTtc * window.config.currency.rate / 100,
        currency: window.config.currency.code,
        shipping: cart.shippingTotal * window.config.currency.rate / 100,
        tax: (cart.totalTtc - cart.totalHt) * window.config.currency.rate / 100,
        items: []
      }
      if(cart.promotionCoupon?.code) {
        datas.coupon = cart.promotionCoupon?.code;
      }
      cart.items.forEach( (item, index) => {
        const itemDatas = {
          item_name: item.variant.product.name,
          item_id: item.variant.code,
          item_brand: "Mad et Len",
          price: item.unitPriceTtc * window.config.currency.rate / 100,
          item_category: item.variant.product.mainTaxon.name,
          item_variant: item.variant.name,
          quantity: item.quantity,
          index
        }
        if(cart.promotionCoupon?.code) {
          itemDatas.discount = (item.undiscountedTotalTtc - item.totalTtc) * window.config.currency.rate / 100;
        }
        datas.items.push(itemDatas)
      })
      if(window.gtag_send) window.gtag_send('purchase', datas);
    },

    _onSubmit() {
      this.errorCheckConditions = !this.terms;
      if(!this.terms) {
        AppControlService.abortStep();
        return;
      }
      if(this.isLoadingPayment) return;
      this.isLoadingPayment = true;

      if(this.order.totalTtc > 0) {

        OrdersService.confirm().then( () => {
          if(this.order.cartPayment.method.code === 'cb-stripe') {
            CardService.paymentStripe(this._card.cardNumber).then( () => {
              this._paymentSuccess();
            }).catch((err) => {
              console.error(err);
              let error = err.error?.message ? err.error.message : err.response?.message;
              if(err.response?.data) error = err.response.data['hydra:description'];
              this.errorPaiement = error;
              AppControlService.abortStep();
            }).then( () => {
              AppControlService.abortStep();
              this.isLoadingPayment = false;
            });
          } else if(this.order.cartPayment.method.code === 'cb-paypal') {
            this._cardFields.submit({
              cardholderName: `${this.order.billingAddress.firstName} ${this.order.billingAddress.lastName}`,
              billingAddress: {
                streetAddress: `${this.order.billingAddress.houseNumber} ${this.order.billingAddress.street}`,
                extendedAddress: this.order.billingAddress.complement ? this.order.billingAddress.complement : '',
                locality: this.order.billingAddress.city,
                postalCode: this.order.billingAddress.postcode,
                countryCodeAlpha2: this.order.billingAddress.countryCode
              }
            }).then( () => {
              CardService.confirmPaypalCB().then( () => {
                this._paymentSuccess();
              }).catch((err) => {
                console.error(err);
                let error = err.error?.message ? err.error.message : err.response?.message;
                if(err.response?.data) error = err.response.data['hydra:description'];
                this.errorPaiement = error;
                AppControlService.abortStep();
              })
            }).catch((err) => {
              console.error(err);
              const errorDetail = Array.isArray(err.details) && err.details[0];
              if (errorDetail) {
                this.errorPaiement = 'Sorry, your transaction could not be processed.';
                if (errorDetail.description)
                  this.errorPaiement += '\n\n' + errorDetail.description
                if (err.debug_id)
                  this.errorPaiement += ' (' + err.debug_id + ')'
              } else {
                let error = err.error?.message ? err.error.message : err.response?.message;
                if(err.response?.data) error = err.response.data['hydra:description'];
                this.errorPaiement = error;
              }
            }).then( () => {
              AppControlService.abortStep();
              this.isLoadingPayment = false;
            });
          }
        }).catch((err) => {
          let error = err.error?.message ? err.error.message : err.response?.message;
          if(err.response?.data) error = err.response.data['hydra:description'];
          this.errorPaiement = error;
          AppControlService.abortStep();
          this.isLoadingPayment = false;
        });
      } else {
        CardService.paymentFree(OrdersService.cart).then( () => {
          AppControlService.goToNextStep();
        }).catch((err) => {
          let error = err.error?.message ? err.error.message : err.response?.message;
          if(err.response?.data) error = err.response.data['hydra:description'];
          this.errorPaiement = error;
          console.error(err);
        }).then( () => {
          AppControlService.abortStep();
          this.isLoadingPayment = false;
        });
      }
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },
  }
}
</script>
<style scoped lang="scss">
.cart-checkout {
  padding: rem(40) rem(20);
  @include tablet {
    width: 50%;
    padding: rem(40);
  }
  .form-group {
    margin-top: rem(15);
  }
  .form-display {
    margin-bottom: rem(20);
  }
  .form-button {
    margin-top: rem(20);
  }
  .form-error {
    opacity: 1;
  }
  .std-form {
    margin-bottom: rem(10);
    .cart-form-wrapper {
      max-width: rem(310);
    }
    .card-input {
      padding-top: rem(3);
      padding-bottom: rem(3);
    }
    .card-input,
    .card-area {
      height: rem(30);
      border-bottom: rem(1) solid $black;
      &.invalid + .form-error {
        @include visible;
      }
    }
  }
  .cart-error {
    color: $color-error;
    font-size: rem(14);
  }
}
</style>